export default class CancelOrder {
  orders: CancelOrders[];
}

interface CancelOrders {
  orderId: string;
  flightOrderRefundRequests: FlightOrderRefundRequest[];
  isOutOfQuota: boolean;
  isOutOfProviderQuota: boolean;
}
interface FlightOrderRefundRequest {
  orderId: string;
  refundTo: number;
  total: number;
  currencyId: string;
}
